import App from './App';
import { ProviderProps } from 'edocatbase/Global';
import { Provider } from 'react-redux';
import EdocatThemeProvider from '../../global/utils/ThemeProvider';


export default class RootComponent extends React.PureComponent<ProviderProps> {
  render() {
    return (
      <Provider store={this.props.store}>
        <EdocatThemeProvider>
          <App />
        </EdocatThemeProvider>
      </Provider>
    );
  }
}
